import { render } from "./MCToCN.vue?vue&type=template&id=66f4e9d9&scoped=true"
import script from "./MCToCN.vue?vue&type=script&lang=js"
export * from "./MCToCN.vue?vue&type=script&lang=js"

import "./MCToCN.vue?vue&type=style&index=0&id=66f4e9d9&lang=scss&scoped=true"
import "./MCToCN.vue?vue&type=style&index=1&id=66f4e9d9&lang=scss"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f4e9d9"]])

export default __exports__